<div
  class="page min-h-screen bg-white font-sans text-gray-900 selection:bg-orange-100 selection:text-brand"
  data-testid="landing-page"
>
  <!-- Navigation -->
  <nav class="fixed w-full z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-testid="navbar">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <div class="flex items-center">
          <img src="images/logo.png" alt="JustTeach Logo" class="h-6 w-auto" data-testid="logo" />
        </div>

        <!-- Desktop Nav -->
        <div class="hidden md:flex items-center space-x-8" data-testid="desktop-nav">
          <a
            href="#features"
            (click)="scrollToSection($event, 'features')"
            class="text-gray-600 hover:text-brand font-medium transition"
            data-testid="nav-features-link"
            >Features</a
          >
          <a
            href="#how-it-works"
            (click)="scrollToSection($event, 'how-it-works')"
            class="text-gray-600 hover:text-brand font-medium transition"
            data-testid="nav-how-it-works-link"
            >How it Works</a
          >
          <!--  Hidden temporary, don't delete it-->
          <!--          <a href="#pricing" (click)="scrollToSection($event, 'pricing')" class="text-gray-600 hover:text-brand font-medium transition"-->
          <!--          >Pricing</a-->
          <!--          >-->
          <button
            (click)="goToLogin()"
            class="text-gray-900 font-medium hover:text-brand transition cursor-pointer"
            id="header-login-btn-web"
            data-testid="nav-login-btn"
          >
            Log in
          </button>
          <button
            (click)="goToAuth()"
            class="bg-brand hover:bg-brand-dark text-white px-5 py-2.5 rounded-full font-medium transition shadow-lg shadow-brand/20 cursor-pointer"
            id="header-start-btn-web"
            data-testid="nav-get-started-btn"
          >
            Get Started Free
          </button>
        </div>

        <!-- Mobile menu button -->
        <div class="md:hidden">
          <button (click)="toggleMenu()" class="text-gray-600 p-2" data-testid="mobile-menu-toggle">
            @if (isMenuOpen()) {
              <lucide-icon [img]="icons.X" class="w-6 h-6"></lucide-icon>
            } @else {
              <lucide-icon [img]="icons.Menu" class="w-6 h-6"></lucide-icon>
            }
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Nav -->
    @if (isMenuOpen()) {
      <div class="md:hidden bg-white border-b border-gray-100 px-4 py-4 space-y-4 shadow-xl" data-testid="mobile-menu">
        <a
          href="#features"
          (click)="scrollToSection($event, 'features'); closeMenu()"
          class="block text-gray-600 font-medium hover:text-brand transition px-2 py-2"
          data-testid="mobile-nav-features-link"
          >Features</a
        >
        <a
          href="#how-it-works"
          (click)="scrollToSection($event, 'how-it-works'); closeMenu()"
          class="block text-gray-600 font-medium hover:text-brand transition px-2 py-2"
          data-testid="mobile-nav-how-it-works-link"
          >How it Works</a
        >
        <!--  Hidden temporary, don't delete it-->
        <!--        <a-->
        <!--          href="#pricing"-->
        <!--          (click)="scrollToSection($event, 'pricing'); closeMenu()"-->
        <!--          class="block text-gray-600 font-medium hover:text-brand transition px-2 py-2"-->
        <!--        >Pricing</a-->
        <!--        >-->
        <button
          (click)="goToLogin(); closeMenu()"
          class="block w-full text-left text-gray-600 font-medium hover:text-brand transition px-2 py-2 cursor-pointer"
          id="header-login-btn-mob"
          data-testid="mobile-nav-login-btn"
        >
          Log in
        </button>
        <button
          (click)="goToAuth(); closeMenu()"
          class="w-full text-center bg-brand text-white py-3 rounded-lg font-medium shadow-md cursor-pointer"
          id="header-start-btn-mob"
          data-testid="mobile-nav-get-started-btn"
        >
          Get Started Free
        </button>
      </div>
    }
  </nav>

  <!-- Hero Section -->
  <section class="pt-28 pb-16 lg:pt-40 lg:pb-28 overflow-hidden" data-testid="hero-section">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div class="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
        <div
          class="inline-flex items-center gap-2 bg-orange-50 border border-orange-100 text-brand px-4 py-1.5 rounded-full text-sm font-semibold mb-6 animate-fade-in-up"
          data-testid="hero-badge"
        >
          <lucide-icon [img]="icons.Clock" class="w-4 h-4"></lucide-icon>
          <span>Save 5+ hours this week</span>
        </div>
        <h1
          class="text-4xl sm:text-5xl lg:text-7xl font-extrabold tracking-tight mb-6 text-gray-900 leading-tight"
          data-testid="hero-heading"
        >
          Stop working
          <span class="text-transparent bg-clip-text bg-gradient-to-r from-brand to-red-600"
            >weekends.</span
          >
        </h1>
        <p class="text-lg sm:text-xl text-gray-600 mb-8 lg:mb-10 leading-relaxed px-4" data-testid="hero-subheading">
          Generate scripted lesson plans in 60 seconds and grade papers automatically with AI. Get
          your Sunday nights back.
        </p>
        <div class="flex flex-col sm:flex-row gap-4 justify-center items-center px-4" data-testid="hero-cta-buttons">
          <button
            (click)="goToAuth()"
            class="w-full sm:w-auto px-8 py-4 bg-brand text-white rounded-full font-bold text-lg hover:bg-brand-dark transition shadow-xl shadow-brand/20 flex items-center justify-center gap-2 cursor-pointer"
            id="hero-block-generate-plan-btn"
            data-testid="hero-generate-plan-btn"
          >
            Generate a Lesson Plan
            <lucide-icon [img]="icons.ArrowRight" class="w-5 h-5"></lucide-icon>
          </button>
          <button
            (click)="goToAuth()"
            class="w-full sm:w-auto px-8 py-4 bg-white text-gray-700 border border-gray-200 rounded-full font-bold text-lg hover:bg-gray-50 transition flex items-center justify-center gap-2 cursor-pointer"
            id="hero-block-try-auto-grading-btn"
            data-testid="hero-try-grading-btn"
          >
            Try Auto-Grading
          </button>
        </div>
        <p class="mt-4 text-sm text-gray-500" data-testid="hero-disclaimer">Start instantly. No commitment or complex setup.</p>
      </div>

      <!-- Abstract UI Representation -->
      <div class="relative mx-auto max-w-6xl px-2 sm:px-0">
        <!-- Background Decor -->
        <div
          class="hidden sm:block absolute -top-10 -left-10 w-72 h-72 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"
        ></div>
        <div
          class="hidden sm:block absolute -top-10 -right-10 w-72 h-72 bg-yellow-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"
        ></div>
        <div
          class="relative bg-white border border-gray-200 rounded-2xl shadow-2xl overflow-hidden grid md:grid-cols-2"
        >
          <!-- Left Side: Lesson Planner UI -->
          <div class="p-6 lg:p-8 border-b md:border-b-0 md:border-r border-gray-100 bg-gray-50/80">
            <!-- Header -->
            <div class="flex items-center justify-between mb-6">
              <div class="flex items-center gap-2">
                <div class="flex gap-1.5">
                  <div class="w-2.5 h-2.5 rounded-full bg-red-400"></div>
                  <div class="w-2.5 h-2.5 rounded-full bg-yellow-400"></div>
                  <div class="w-2.5 h-2.5 rounded-full bg-green-400"></div>
                </div>
              </div>
              <div
                class="flex items-center gap-2 bg-white py-1 px-2 rounded-lg border border-gray-200 shadow-sm"
              >
                <lucide-icon [img]="icons.Sparkles" class="w-3 h-3 text-brand"></lucide-icon>
                <span class="text-xs font-bold text-gray-700 uppercase tracking-wider"
                  >Lesson Generator</span
                >
              </div>
            </div>

            <div class="space-y-6 relative z-10">
              <!-- Input Section -->
              <div class="bg-white p-1 rounded-xl shadow-sm border border-gray-200">
                <div class="border-b border-gray-100 p-2 flex items-center gap-2 flex-wrap">
                  <span
                    class="text-[10px] font-bold bg-orange-100 text-orange-700 px-2 py-0.5 rounded-full whitespace-nowrap"
                    >5th Grade</span
                  >
                  <span
                    class="text-[10px] font-bold bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full whitespace-nowrap"
                    >Science</span
                  >
                  <span
                    class="text-[10px] font-bold bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full flex items-center gap-1 whitespace-nowrap"
                  >
                    <lucide-icon [img]="icons.SlidersHorizontal" class="w-3 h-3"></lucide-icon> NGSS
                    Standards
                  </span>
                </div>
                <div class="p-3 bg-gray-50 rounded-b-lg relative">
                  <p class="text-sm text-gray-700 font-medium leading-relaxed">
                    <span class="text-gray-400 mr-2">Prompt:</span>
                    Create a highly engaging lesson on "Photosynthesis". Include a hands-on
                    experiment and a scripted hook for diverse learners.
                  </p>
                  <div
                    class="absolute bottom-2 right-2 bg-brand w-7 h-7 rounded-lg shadow-md flex items-center justify-center"
                  >
                    <lucide-icon [img]="icons.ArrowRight" class="w-3 h-3 text-white"></lucide-icon>
                  </div>
                </div>
              </div>

              <!-- Transition Arrow -->
              <div class="flex justify-center relative my-2 z-0 opacity-50">
                <div
                  class="bg-orange-100 text-brand w-8 h-8 rounded-full animate-bounce flex items-center justify-center"
                >
                  <lucide-icon [img]="icons.ArrowDown" class="w-4 h-4"></lucide-icon>
                </div>
              </div>

              <!-- Result Section -->
              <div
                class="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden relative"
              >
                <!-- Header -->
                <div
                  class="bg-white border-b border-gray-100 px-4 py-3 flex justify-between items-center"
                >
                  <div class="flex items-center gap-2">
                    <div class="bg-red-100 p-1 rounded text-red-600">
                      <lucide-icon [img]="icons.FileText" class="w-3 h-3"></lucide-icon>
                    </div>
                    <span
                      class="text-xs font-bold text-gray-800 truncate max-w-[100px] sm:max-w-none"
                      >Photosynthesis_Unit.pdf</span
                    >
                  </div>
                  <div class="flex gap-2">
                    <span
                      class="text-[10px] font-medium text-gray-400 bg-gray-50 px-2 py-0.5 rounded border border-gray-100"
                      >Read-only</span
                    >
                  </div>
                </div>

                <!-- Content Preview -->
                <div class="p-5 bg-white relative">
                  <!-- Title & Meta -->
                  <div class="mb-4 pb-3 border-b border-gray-50">
                    <h3 class="text-sm font-bold text-gray-900 mb-2">
                      Lesson 1: Introduction to Plant Energy
                    </h3>
                    <div class="flex flex-wrap gap-2">
                      <span
                        class="text-[10px] font-semibold text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded flex items-center gap-1"
                      >
                        <lucide-icon [img]="icons.Clock" class="w-2.5 h-2.5"></lucide-icon> 45 mins
                      </span>
                      <span
                        class="text-[10px] font-semibold text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded"
                      >
                        5th Grade Science
                      </span>
                    </div>
                  </div>

                  <!-- Script Block -->
                  <div class="space-y-3">
                    <div class="flex items-center gap-2">
                      <span class="w-1.5 h-1.5 rounded-full bg-brand"></span>
                      <span class="text-[10px] font-bold text-gray-400 uppercase tracking-wider"
                        >I. The Hook (5 mins)</span
                      >
                    </div>

                    <div class="relative pl-4 border-l-2 border-brand/30">
                      <div class="bg-orange-50/50 p-3 rounded-r-lg rounded-bl-lg">
                        <div class="flex items-center gap-1.5 mb-1.5">
                          <span
                            class="bg-brand text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wide"
                            >Teacher Script</span
                          >
                        </div>
                        <p class="text-xs text-gray-700 font-medium leading-relaxed font-serif">
                          "Raise your hand if you had breakfast today. Keep it up if you had to
                          stand in the sun to get full? No one?
                          <span class="bg-brand/10 text-brand"
                            >That's what makes plants like superheroes...</span
                          >"
                        </p>
                      </div>
                    </div>
                    <div class="flex items-center gap-2 opacity-60">
                      <span class="w-1.5 h-1.5 rounded-full bg-gray-300"></span>
                      <span class="text-[10px] font-bold text-gray-400 uppercase tracking-wider"
                        >II. Direct Instruction</span
                      >
                    </div>
                    <div class="pl-4 space-y-1.5">
                      <div class="h-2 bg-gray-100 rounded w-full"></div>
                      <div class="h-2 bg-gray-100 rounded w-5/6"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Side: Grading UI -->
          <div class="p-6 lg:p-8 bg-white relative overflow-hidden flex flex-col">
            <div
              class="absolute top-0 right-0 bg-gradient-to-r from-green-500 to-green-600 text-white text-[10px] font-bold px-3 py-1.5 rounded-bl-lg shadow-sm flex items-center gap-1"
            >
              <lucide-icon [img]="icons.Zap" class="w-3 h-3"></lucide-icon>
              DONE IN 12s
            </div>

            <!-- Header -->
            <div class="flex items-center justify-between mb-6">
              <div
                class="flex items-center gap-2 bg-gray-50 py-1 px-2 rounded-lg border border-gray-100 shadow-sm"
              >
                <lucide-icon [img]="icons.CheckCircle" class="w-3 h-3 text-brand"></lucide-icon>
                <span class="text-xs font-bold text-gray-700 uppercase tracking-wider"
                  >Auto-Grader</span
                >
              </div>
              <span
                class="hidden sm:block text-[10px] font-medium text-gray-400 bg-gray-50 px-2 py-1 rounded-full border border-gray-100"
                >Rubric Applied: 5th Grade Persuasive</span
              >
            </div>

            <div class="space-y-3 flex-1 relative z-10">
              <!-- Main Active Card -->
              <div
                class="bg-white p-4 rounded-xl border border-orange-200 relative group cursor-pointer shadow-md transition-all hover:shadow-lg"
              >
                <div class="absolute top-2 right-2">
                  <lucide-icon
                    [img]="icons.MoreHorizontal"
                    class="w-4 h-4 text-gray-300"
                  ></lucide-icon>
                </div>
                <div class="flex items-start gap-3">
                  <div class="bg-orange-50 p-2.5 rounded-lg border border-orange-100 relative">
                    <lucide-icon [img]="icons.FileText" class="w-6 h-6 text-brand"></lucide-icon>
                    <div
                      class="absolute -bottom-1 -right-1 bg-green-500 w-3 h-3 border-2 border-white rounded-full"
                    ></div>
                  </div>
                  <div class="flex-1">
                    <div class="flex justify-between items-center mb-1 pr-4">
                      <p
                        class="text-sm font-bold text-gray-900 truncate max-w-[140px] sm:max-w-none"
                      >
                        Emily's Essay_FINAL.pdf
                      </p>
                    </div>
                    <div class="flex items-center gap-2 mb-3">
                      <span class="text-2xl font-extrabold text-gray-900">92%</span>
                      <span
                        class="text-sm font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded-md"
                        >A-</span
                      >
                    </div>

                    <!-- Detailed AI Feedback Simulation -->
                    <div
                      class="bg-gray-50 p-3 rounded-lg text-xs text-gray-700 border border-gray-100 relative leading-relaxed font-medium break-words min-w-0"
                    >
                      <div class="absolute -top-2 left-2 bg-white px-1">
                        <div
                          class="flex gap-1 items-center bg-brand text-white px-1.5 py-0.5 rounded text-[10px] font-bold"
                        >
                          <lucide-icon [img]="icons.Sparkles" class="w-2.5 h-2.5"></lucide-icon>
                          AI Feedback
                        </div>
                      </div>
                      <span class="text-gray-400">Strengths:</span> Excellent thesis statement
                      clearly stating position.<br />
                      <span class="text-gray-400">To Improve:</span> Transition between paragraph 2
                      and 3 needs strengthening.
                    </div>
                  </div>
                </div>
              </div>

              <!-- Queue/Batch List -->
              <div class="space-y-2 pl-2">
                <p class="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">
                  Up Next in Queue (7)
                </p>
                <div
                  class="bg-gray-50 p-2 rounded-lg border border-gray-100 flex justify-between items-center opacity-80 hover:opacity-100 transition"
                >
                  <div class="flex items-center gap-2">
                    <lucide-icon
                      [img]="icons.UploadCloud"
                      class="w-4 h-4 text-gray-400"
                    ></lucide-icon>
                    <span
                      class="text-xs font-medium text-gray-700 truncate max-w-[120px] sm:max-w-none"
                      >Noah_W_Handwriting.jpg</span
                    >
                  </div>
                  <div
                    class="flex items-center gap-1 text-xs font-bold text-yellow-600 bg-yellow-50 px-2 py-0.5 rounded"
                  >
                    <span class="w-2 h-2 rounded-full bg-yellow-500 animate-pulse"></span>
                    Processing...
                  </div>
                </div>
                <div
                  class="bg-gray-50 p-2 rounded-lg border border-gray-100 flex justify-between items-center opacity-60"
                >
                  <div class="flex items-center gap-2">
                    <lucide-icon [img]="icons.FileText" class="w-4 h-4 text-gray-400"></lucide-icon>
                    <span
                      class="text-xs font-medium text-gray-700 truncate max-w-[120px] sm:max-w-none"
                      >Liam_History.pdf</span
                    >
                  </div>
                  <span class="text-xs text-gray-400 font-medium">Waiting</span>
                </div>
                <div
                  class="bg-gray-50 p-2 rounded-lg border border-gray-100 flex justify-between items-center opacity-50"
                >
                  <div class="flex items-center gap-2">
                    <lucide-icon [img]="icons.FileText" class="w-4 h-4 text-gray-400"></lucide-icon>
                    <span
                      class="text-xs font-medium text-gray-700 truncate max-w-[120px] sm:max-w-none"
                      >Emma_Science_Lab.pdf</span
                    >
                  </div>
                  <span class="text-xs text-gray-400 font-medium">Waiting</span>
                </div>
                <div
                  class="bg-gray-50 p-2 rounded-lg border border-gray-100 flex justify-between items-center opacity-40"
                >
                  <div class="flex items-center gap-2">
                    <lucide-icon
                      [img]="icons.UploadCloud"
                      class="w-4 h-4 text-gray-400"
                    ></lucide-icon>
                    <span
                      class="text-xs font-medium text-gray-700 truncate max-w-[120px] sm:max-w-none"
                      >Lucas_Math_Quiz.jpg</span
                    >
                  </div>
                  <span class="text-xs text-gray-400 font-medium">Waiting</span>
                </div>
                <div
                  class="bg-gray-50 p-2 rounded-lg border border-gray-100 flex justify-between items-center opacity-30"
                >
                  <div class="flex items-center gap-2">
                    <lucide-icon [img]="icons.FileText" class="w-4 h-4 text-gray-400"></lucide-icon>
                    <span
                      class="text-xs font-medium text-gray-700 truncate max-w-[120px] sm:max-w-none"
                      >Olivia_Reading_Log.docx</span
                    >
                  </div>
                  <span class="text-xs text-gray-400 font-medium">Waiting</span>
                </div>
              </div>
            </div>

            <!-- Background blurry elements -->
            <div
              class="absolute bottom-0 right-0 w-32 h-32 bg-orange-100 rounded-full mix-blend-multiply filter blur-2xl opacity-30 pointer-events-none"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Social Proof -->
  <section class="py-12 bg-gray-50 border-y border-gray-100" data-testid="social-proof-section">
    <div class="max-w-7xl mx-auto px-4 text-center">
      <p class="text-sm font-semibold text-gray-500 uppercase tracking-widest mb-6" data-testid="social-proof-heading">
        Trusted by 10,000+ happy teachers
      </p>
      <div
        class="flex flex-wrap justify-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition duration-500"
        data-testid="social-proof-partners"
      >
        <!-- Placeholders for logos -->
        <div class="flex items-center gap-2 font-bold text-lg sm:text-xl text-gray-700" data-testid="social-proof-partner-0">
          <div class="w-5 h-5 sm:w-6 sm:h-6 bg-gray-400 rounded-full">
            <img class="rounded-full" src="/images/landing/next-gen.png" />
          </div>
          NextGen Classroom
        </div>
        <div class="flex items-center gap-2 font-bold text-lg sm:text-xl text-gray-700" data-testid="social-proof-partner-1">
          <div class="w-5 h-5 sm:w-6 sm:h-6 bg-gray-400 rounded-full">
            <img class="rounded-full" src="/images/landing/apex.png" />
          </div>
          Apex Youth Development
        </div>
        <div class="flex items-center gap-2 font-bold text-lg sm:text-xl text-gray-700" data-testid="social-proof-partner-2">
          <div class="w-5 h-5 sm:w-6 sm:h-6 bg-gray-400 rounded-full">
            <img class="rounded-full" src="/images/landing/meridian.png" />
          </div>
          Meridian Learning Group
        </div>
        <div class="flex items-center gap-2 font-bold text-lg sm:text-xl text-gray-700" data-testid="social-proof-partner-3">
          <div class="w-5 h-5 sm:w-6 sm:h-6 bg-gray-400 rounded-full">
            <img class="rounded-full" src="/images/landing/scholar-stream.png" />
          </div>
          Scholar Stream Tutors
        </div>
      </div>
    </div>
  </section>

  <!-- Feature 1: Lesson Planning -->
  <section id="features" class="py-16 lg:py-32" data-testid="features-section">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
        <div>
          <div
            class="inline-block px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-sm font-bold mb-4"
            data-testid="features-badge"
          >
            Don't write from scratch
          </div>
          <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-testid="features-heading">
            Scripted Lesson Plans.<br />
            <span class="text-brand">Generated instantly.</span>
          </h2>
          <p class="text-lg text-gray-600 mb-8" data-testid="features-description">
            Tell us your grade, subject, and standard. We'll generate a comprehensive script
            including hooks, direct instruction, activities, and checks for understanding.
          </p>
          <ul class="space-y-4" data-testid="features-list">
            @for (item of lessonFeatures; track item; let i = $index) {
              <li class="flex items-center gap-3" [attr.data-testid]="'feature-item-' + i">
                <lucide-icon
                  [img]="icons.CheckCircle"
                  class="w-5 h-5 text-green-500 flex-shrink-0"
                ></lucide-icon>
                <span class="text-gray-700 font-medium">{{ item }}</span>
              </li>
            }
          </ul>
        </div>

        <!-- Visual representation of a lesson plan -->
        <div
          class="bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden transform md:rotate-2 md:hover:rotate-0 transition duration-500"
        >
          <!-- Fake Toolbar -->
          <div class="bg-gray-50 border-b border-gray-100 p-3 flex items-center justify-between">
            <div class="flex gap-2">
              <div class="w-3 h-3 rounded-full bg-red-400"></div>
              <div class="w-3 h-3 rounded-full bg-yellow-400"></div>
              <div class="w-3 h-3 rounded-full bg-green-400"></div>
            </div>
            <div class="flex gap-2">
              <div
                class="px-2 py-1 bg-white border border-gray-200 rounded text-[10px] font-medium text-gray-500 uppercase tracking-wide text-gray-400"
              >
                Export PDF
              </div>
              <div
                class="px-2 py-1 bg-brand border border-brand rounded text-[10px] font-bold text-white uppercase tracking-wide"
              >
                Save
              </div>
            </div>
          </div>

          <!-- Content -->
          <div class="p-6 md:p-8 bg-white">
            <!-- Header -->
            <div class="flex justify-between items-start mb-6 border-b border-gray-100 pb-4">
              <div>
                <h3 class="text-xl font-bold text-gray-900 mb-2">
                  Photosynthesis: Nature's Solar Power
                </h3>
                <div class="flex gap-2 text-xs font-bold">
                  <span class="bg-green-100 text-green-700 px-2 py-1 rounded">Science</span>
                  <span class="bg-blue-100 text-blue-700 px-2 py-1 rounded">5th Grade</span>
                  <span class="bg-gray-100 text-gray-600 px-2 py-1 rounded">45 mins</span>
                </div>
              </div>
            </div>

            <!-- Sections -->
            <div class="space-y-6 text-left">
              <!-- Objective -->
              <div>
                <h4 class="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">
                  1. Learning Objective
                </h4>
                <p class="text-sm text-gray-700 leading-relaxed font-medium">
                  By the end of this lesson, students will be able to
                  <span class="bg-yellow-100 px-1 rounded-sm">define photosynthesis</span> and
                  identify the three main inputs (sunlight, water, CO2) required for the process.
                </p>
              </div>

              <!-- The Hook -->
              <div>
                <h4 class="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">
                  2. The Hook (5 mins)
                </h4>
                <div class="bg-orange-50 p-4 rounded-lg border-l-4 border-brand">
                  <div class="flex items-center gap-2 mb-2">
                    <span
                      class="text-[10px] bg-brand text-white px-1.5 py-0.5 rounded font-bold uppercase"
                      >Script</span
                    >
                    <span class="text-xs text-brand font-bold uppercase">Teacher Says:</span>
                  </div>
                  <p class="text-sm text-gray-800 italic font-serif leading-relaxed">
                    "Raise your hand if you had breakfast today. Now, raise your hand if you had to
                    stand in the sun to get full? No one? Well, imagine if you could..."
                  </p>
                </div>
              </div>

              <!-- Activity -->
              <div>
                <h4 class="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">
                  3. Activity: Leaf Factory
                </h4>
                <div
                  class="flex items-center gap-3 p-3 border border-gray-100 rounded-lg bg-gray-50"
                >
                  <div class="bg-white p-2 rounded shadow-sm text-green-600 border border-gray-100">
                    <lucide-icon [img]="icons.CheckCircle" class="w-4 h-4"></lucide-icon>
                  </div>
                  <span class="text-sm text-gray-700 font-medium"
                    >Distribute "Leaf Diagram" worksheets</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Feature 2: Grading (The Pain Point) -->
  <section id="auto-grader" class="py-16 lg:py-32 bg-gray-900 text-white overflow-hidden" data-testid="auto-grader-section">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
        <!-- Visual representation of grading -->
        <div class="relative order-2 md:order-1" data-testid="auto-grader-visual">
          <div class="absolute inset-0 bg-brand blur-3xl opacity-20 rounded-full"></div>
          <div
            class="relative bg-gray-800 rounded-2xl border border-gray-700 p-1 shadow-2xl transform md:-rotate-2 md:hover:rotate-0 transition duration-500 ease-out"
          >
            <!-- Header Card -->
            <div class="bg-gray-800 rounded-t-xl p-4 pb-6">
              <!-- Mac Window Controls -->
              <div class="flex gap-2 mb-4">
                <div class="w-3 h-3 rounded-full bg-[#ff5f57]"></div>
                <div class="w-3 h-3 rounded-full bg-[#febc2e]"></div>
                <div class="w-3 h-3 rounded-full bg-[#28c840]"></div>
              </div>
              <div class="flex items-center justify-between mb-4">
                <div>
                  <h4 class="text-lg font-bold text-white">Batch Grading Session</h4>
                  <p class="text-sm text-gray-400">5th Grade History Essays</p>
                </div>
                <div
                  class="bg-brand/20 text-brand text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1"
                >
                  <lucide-icon [img]="icons.Zap" class="w-3 h-3"></lucide-icon>
                  TIME SAVED: ~3 HOURS
                </div>
              </div>

              <!-- Progress Bar -->
              <div class="space-y-2">
                <div class="flex justify-between text-xs font-bold mb-1">
                  <span class="text-white">Grading 25/25 Papers</span>
                  <span class="text-brand">Total Time: 2m 15s</span>
                </div>
                <div class="h-2 w-full bg-gray-700 rounded-full overflow-hidden">
                  <div
                    class="h-full bg-gradient-to-r from-brand to-orange-500 w-full rounded-full shadow-[0_0_10px_rgba(245,102,0,0.5)]"
                  ></div>
                </div>
              </div>
            </div>

            <!-- Results List -->
            <div class="bg-gray-900/50 p-4 rounded-b-xl space-y-3">
              <!-- Student 1 - The Hero Entry -->
              <div
                class="bg-gray-800 p-3 rounded-lg border border-gray-700 hover:border-brand transition group relative overflow-hidden"
              >
                <div
                  class="absolute inset-0 bg-brand opacity-0 group-hover:opacity-5 transition"
                ></div>
                <div class="flex justify-between items-start mb-3 relative z-10">
                  <div class="flex items-center gap-3">
                    <div class="bg-gray-700 p-1.5 rounded">
                      <lucide-icon
                        [img]="icons.FileText"
                        class="w-4 h-4 text-gray-300"
                      ></lucide-icon>
                    </div>
                    <div>
                      <p class="text-sm font-bold text-white">Emily Davis</p>
                      <p class="text-xs text-gray-400">Essay_Final.pdf</p>
                    </div>
                  </div>
                  <span class="text-green-400 text-base font-bold">A- (92%)</span>
                </div>

                <!-- AI Feedback Snippet -->
                <div
                  class="relative z-10 bg-gray-900/50 p-3 rounded text-xs text-gray-300 border-l-2 border-brand flex gap-2"
                >
                  <lucide-icon
                    [img]="icons.Sparkles"
                    class="w-4 h-4 text-brand flex-shrink-0 mt-0.5"
                  ></lucide-icon>
                  <div>
                    <span class="font-bold text-brand">AI Feedback Snapshot:</span> "Strong use of
                    primary sources to support your thesis in paragraph 3. Consider adding a
                    counter-argument to strengthen your conclusion."
                  </div>
                </div>
              </div>

              <!-- Student 2 - Simplified Entry -->
              <div
                class="bg-gray-800 p-3 rounded-lg border border-gray-700 opacity-60 flex justify-between items-center"
              >
                <div class="flex items-center gap-3">
                  <div class="bg-gray-700 p-1.5 rounded">
                    <lucide-icon
                      [img]="icons.UploadCloud"
                      class="w-4 h-4 text-gray-300"
                    ></lucide-icon>
                  </div>
                  <span class="text-sm font-medium text-white">Michael Chen (Handwriting)</span>
                </div>
                <span class="text-yellow-400 text-sm font-bold">B+ (88%)</span>
              </div>

              <!-- Student 3 - Simplified Entry -->
              <div
                class="bg-gray-800 p-3 rounded-lg border border-gray-700 opacity-40 flex justify-between items-center"
              >
                <div class="flex items-center gap-3">
                  <div class="bg-gray-700 p-1.5 rounded">
                    <lucide-icon [img]="icons.FileText" class="w-4 h-4 text-gray-300"></lucide-icon>
                  </div>
                  <span class="text-sm font-medium text-white">Sarah Johnson</span>
                </div>
                <span class="text-green-400 text-sm font-bold">A (95%)</span>
              </div>
            </div>
          </div>
        </div>

        <div class="order-1 md:order-2">
          <div
            class="inline-block px-3 py-1 bg-red-500/10 text-red-300 rounded-full text-sm font-bold mb-4"
            data-testid="auto-grader-badge"
          >
            Drowning in grading?
          </div>
          <h2 class="text-3xl sm:text-4xl font-bold mb-6" data-testid="auto-grader-heading">
            Grade automatically.<br />
            <span class="text-brand">Done in seconds.</span>
          </h2>
          <p class="text-lg text-gray-400 mb-8" data-testid="auto-grader-description">
            Upload essays, worksheets, or even photos of handwriting. Our AI applies your specific
            rubric and provides personalized feedback for every student.
          </p>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-6" data-testid="auto-grader-benefits">
            <div class="bg-gray-800 p-4 rounded-xl border border-gray-700" data-testid="auto-grader-benefit-0">
              <h4 class="text-white font-bold mb-1">Consistent</h4>
              <p class="text-sm text-gray-400">Removes bias and fatigue from grading.</p>
            </div>
            <div class="bg-gray-800 p-4 rounded-xl border border-gray-700" data-testid="auto-grader-benefit-1">
              <h4 class="text-white font-bold mb-1">Personalized</h4>
              <p class="text-sm text-gray-400">Constructive feedback, not just a score.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Steps / How it works -->
  <section id="how-it-works" class="py-16 lg:py-32 bg-gray-50" data-testid="how-it-works-section">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl font-bold text-gray-900" data-testid="how-it-works-heading">How it works</h2>
        <p class="text-gray-600 mt-2" data-testid="how-it-works-subheading">Simplicity is our superpower.</p>
      </div>

      <div class="grid md:grid-cols-3 gap-8" data-testid="how-it-works-steps">
        @for (step of howItWorksSteps; track step.title; let i = $index) {
          <div
            class="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative group hover:-translate-y-1 transition duration-300"
            [attr.data-testid]="'how-it-works-step-' + i"
          >
            <div
              class="bg-orange-50 w-12 h-12 rounded-lg flex items-center justify-center text-brand mb-6 group-hover:bg-brand group-hover:text-white transition"
            >
              @switch (step.icon) {
                @case ('Layout') {
                  <lucide-icon [img]="icons.Layout" class="w-6 h-6"></lucide-icon>
                }
                @case ('Sparkles') {
                  <lucide-icon [img]="icons.Sparkles" class="w-6 h-6"></lucide-icon>
                }
                @case ('Clock') {
                  <lucide-icon [img]="icons.Clock" class="w-6 h-6"></lucide-icon>
                }
              }
            </div>
            <h3 class="text-xl font-bold text-gray-900 mb-3" [attr.data-testid]="'how-it-works-step-' + i + '-title'">{{ step.title }}</h3>
            <p class="text-gray-600" [attr.data-testid]="'how-it-works-step-' + i + '-desc'">{{ step.desc }}</p>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- Testimonials Section -->
  <section class="py-20 bg-white border-y border-gray-100" data-testid="testimonials-section">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-testid="testimonials-heading">
          Why teachers love JustTeach
        </h2>
        <div class="flex justify-center gap-1 mb-4" data-testid="testimonials-stars">
          @for (i of [1, 2, 3, 4, 5]; track i) {
            <lucide-icon
              [img]="icons.Star"
              class="w-5 h-5 text-yellow-400 fill-yellow-400"
            ></lucide-icon>
          }
        </div>
        <p class="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto" data-testid="testimonials-subheading">
          Join a community of educators who have reclaimed their weekends.
        </p>
      </div>

      <div class="grid md:grid-cols-3 gap-8" data-testid="testimonials-grid">
        @for (testimonial of testimonials; track testimonial.name; let i = $index) {
          <div
            class="bg-gray-50 p-8 rounded-2xl border border-gray-100 relative hover:shadow-lg transition duration-300 flex flex-col justify-between"
            [attr.data-testid]="'testimonial-' + i"
          >
            <lucide-icon
              [img]="icons.Quote"
              class="absolute top-8 right-8 w-8 h-8 text-brand/10"
            ></lucide-icon>

            <p class="text-gray-700 italic leading-relaxed mb-8 relative z-10" [attr.data-testid]="'testimonial-' + i + '-quote'">
              "{{ testimonial.quote }}"
            </p>

            <div class="flex items-center gap-4">
              <div
                class="w-10 h-10 rounded-full bg-brand/10 text-brand flex items-center justify-center font-bold text-sm"
              >
                <img class="rounded-full" [src]="testimonial.image" [attr.data-testid]="'testimonial-' + i + '-image'" />
              </div>
              <div>
                <h4 class="font-bold text-gray-900 text-sm" [attr.data-testid]="'testimonial-' + i + '-name'">{{ testimonial.name }}</h4>
                <p class="text-xs text-gray-500" [attr.data-testid]="'testimonial-' + i + '-role'">{{ testimonial.role }}</p>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- FAQ Section -->
  <section class="py-20 bg-white" data-testid="faq-section">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-gray-900" data-testid="faq-heading">Frequently Asked Questions</h2>
        <p class="text-gray-600 mt-2" data-testid="faq-subheading">Everything you need to know about JustTeach.</p>
      </div>

      <div class="space-y-4" data-testid="faq-list">
        @for (faq of faqs; track faq.question; let i = $index) {
          <div
            class="border border-gray-200 rounded-xl transition-all duration-300"
            [class.bg-orange-50]="isFaqOpen(i)"
            [class.border-brand]="isFaqOpen(i)"
            [class.hover:border-gray-300]="!isFaqOpen(i)"
            [attr.data-testid]="'faq-item-' + i"
          >
            <button
              (click)="toggleFaq(i)"
              class="w-full flex justify-between items-center p-6 text-left focus:outline-none cursor-pointer"
              [attr.data-testid]="'faq-question-' + i"
            >
              <span
                class="font-bold text-lg"
                [class.text-brand]="isFaqOpen(i)"
                [class.text-gray-900]="!isFaqOpen(i)"
              >
                {{ faq.question }}
              </span>
              <div
                class="w-6 h-6 rounded-full transition-colors flex items-center justify-center"
                [class.bg-brand]="isFaqOpen(i)"
                [class.text-white]="isFaqOpen(i)"
                [class.bg-gray-100]="!isFaqOpen(i)"
                [class.text-gray-500]="!isFaqOpen(i)"
                [attr.data-testid]="'faq-toggle-' + i"
              >
                @if (isFaqOpen(i)) {
                  <lucide-icon [img]="icons.Minus" class="w-4 h-4"></lucide-icon>
                } @else {
                  <lucide-icon [img]="icons.Plus" class="w-4 h-4"></lucide-icon>
                }
              </div>
            </button>
            <div
              class="overflow-hidden transition-all duration-300 ease-in-out"
              [class.max-h-48]="isFaqOpen(i)"
              [class.opacity-100]="isFaqOpen(i)"
              [class.max-h-0]="!isFaqOpen(i)"
              [class.opacity-0]="!isFaqOpen(i)"
              [attr.data-testid]="'faq-answer-' + i"
            >
              <p class="px-6 pb-6 text-gray-600 leading-relaxed">
                {{ faq.answer }}
              </p>
            </div>
          </div>
        }
      </div>
    </div>
  </section>

  <!--  Hidden temporary, don't delete it-->
  <!--  &lt;!&ndash; CTA / Pricing Teaser &ndash;&gt;-->
  <!--  <section id="pricing" class="py-20 bg-gray-50">-->
  <!--    <div class="max-w-4xl mx-auto px-4 text-center">-->
  <!--      <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">-->
  <!--        Get your Sunday nights back.-->
  <!--      </h2>-->
  <!--      <p class="text-lg sm:text-xl text-gray-600 mb-10">-->
  <!--        Join thousands of teachers who are planning faster and grading smarter.-->
  <!--      </p>-->

  <!--      <div-->
  <!--        class="bg-white border border-gray-200 rounded-3xl p-8 md:p-12 shadow-xl shadow-gray-200/50"-->
  <!--      >-->
  <!--        <div class="flex flex-col items-center">-->
  <!--          <span-->
  <!--            class="bg-orange-100 text-brand font-bold px-4 py-1 rounded-full text-sm mb-4 shadow-sm border border-brand/20"-->
  <!--          >-->
  <!--            FREE FOREVER PLAN-->
  <!--          </span>-->
  <!--          <h3 class="text-3xl font-bold text-gray-900 mb-2">Start for Free</h3>-->
  <!--          <p class="text-gray-600 mb-8 max-w-md">-->
  <!--            Includes 3 scripted lesson plans and 10 auto-grading credits every single week. No-->
  <!--            credit card required.-->
  <!--          </p>-->
  <!--          <button-->
  <!--            class="w-full sm:w-auto px-10 py-4 bg-brand text-white rounded-full font-bold text-lg hover:bg-brand-dark transition shadow-lg shadow-brand/20"-->
  <!--          >-->
  <!--            Create Free Account-->
  <!--          </button>-->
  <!--          <p class="mt-4 text-sm text-gray-500">Upgrade to Pro anytime for unlimited access.</p>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </section>-->

  <!-- Final CTA Section -->
  <section
    class="py-20 lg:py-28 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden"
    data-testid="final-cta-section"
  >
    <!-- Background decorations -->
    <div
      class="absolute top-0 left-0 w-96 h-96 bg-brand/20 rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 -translate-y-1/2"
    ></div>
    <div
      class="absolute bottom-0 right-0 w-96 h-96 bg-orange-500/20 rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-x-1/2 translate-y-1/2"
    ></div>

    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
      <div
        class="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white px-4 py-2 rounded-full text-sm font-semibold mb-8"
        data-testid="final-cta-badge"
      >
        <lucide-icon [img]="icons.Sparkles" class="w-4 h-4 text-brand"></lucide-icon>
        <span>Ready to transform your teaching?</span>
      </div>

      <h2 class="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-6 leading-tight" data-testid="final-cta-heading">
        Stop planning all weekend.<br />
        <span class="text-transparent bg-clip-text bg-gradient-to-r from-brand to-yellow-400"
          >Start teaching smarter.</span
        >
      </h2>

      <p class="text-lg sm:text-xl text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-testid="final-cta-description">
        Join 10,000+ educators who've reclaimed their personal time. Create your first AI-powered
        lesson plan in under 60 seconds.
      </p>

      <div class="flex justify-center items-center">
        <button
          (click)="goToAuth()"
          class="w-full sm:w-auto px-10 py-4 bg-brand text-white rounded-full font-bold text-base hover:bg-brand-dark transition shadow-xl shadow-brand/30 flex items-center justify-center gap-2 group cursor-pointer"
          id="footer-block-start-btn"
          data-testid="final-cta-btn"
        >
          Get Started Free
          <lucide-icon
            [img]="icons.ArrowRight"
            class="w-5 h-5 group-hover:translate-x-1 transition-transform"
          ></lucide-icon>
        </button>
      </div>

      <p class="mt-6 text-sm text-gray-400" data-testid="final-cta-disclaimer">
        Your first lesson plan is ready in 60 seconds. No setup required.
      </p>
    </div>
  </section>

  <!-- Footer -->
  <footer class="bg-white border-t border-gray-100 pt-16 pb-8" data-testid="footer">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-testid="footer-grid">
        <div class="col-span-2 md:col-span-1">
          <div class="flex items-center mb-4">
            <img src="images/logo.png" alt="JustTeach Logo" class="h-6 w-auto" data-testid="footer-logo" />
          </div>
          <p class="text-gray-500 text-sm" data-testid="footer-tagline">
            Empowering educators with AI to focus on what matters most—students.
          </p>
        </div>
        <div data-testid="footer-product-section">
          <h4 class="font-bold text-gray-900 mb-4">Product</h4>
          <ul class="space-y-2 text-sm text-gray-600" data-testid="footer-product-links">
            <li>
              <a
                href="#features"
                (click)="scrollToSection($event, 'features')"
                class="hover:text-brand cursor-pointer"
                data-testid="footer-lesson-planner-link"
                >Lesson Planner</a
              >
            </li>
            <li>
              <a
                href="#auto-grader"
                (click)="scrollToSection($event, 'auto-grader')"
                class="hover:text-brand cursor-pointer"
                data-testid="footer-auto-grader-link"
                >Auto Grader</a
              >
            </li>
            <li>
              <a
                href="#auto-grader"
                (click)="scrollToSection($event, 'auto-grader')"
                class="hover:text-brand cursor-pointer"
                data-testid="footer-rubric-generator-link"
                >Rubric Generator</a
              >
            </li>
          </ul>
        </div>
        <div data-testid="footer-legal-section">
          <h4 class="font-bold text-gray-900 mb-4">Legal</h4>
          <ul class="space-y-2 text-sm text-gray-600" data-testid="footer-legal-links">
            <li>
              <a
                href="https://docs.google.com/document/d/1WnHgGW4iNKiIsTmkaA9-C4yINg5Ni7ZZGpl3UP8yuNs/edit?tab=t.0#heading=h.sdxxnj1rzsai"
                target="_blank"
                class="hover:text-brand"
                data-testid="footer-privacy-link"
                >Privacy Policy</a
              >
            </li>
            <li>
              <a
                href="https://docs.google.com/document/d/1kdiMyIGMHduRCw_qxe1d3QRiD0UE_6YjyGL_fZfDfA0/edit?hl=ru&tab=t.0#heading=h.e3pdo9sw4qyu"
                target="_blank"
                class="hover:text-brand"
                data-testid="footer-terms-link"
                >Terms of Use</a
              >
            </li>
          </ul>
        </div>
        <div data-testid="footer-contact-section">
          <h4 class="font-bold text-gray-900 mb-4">Contact</h4>
          <ul class="space-y-2 text-xs sm:text-sm text-gray-600">
            <li>
              <a
                href="mailto:justteachsupport@justteach.ai"
                class="hover:text-brand whitespace-nowrap"
                data-testid="footer-email-link"
                >justteachsupport@justteach.ai</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="border-t border-gray-100 pt-8 text-center text-sm text-gray-400" data-testid="footer-copyright">
        &copy; 2025 JustTeach. All rights reserved.
      </div>
    </div>
  </footer>
</div>
